import React from "react"
import styled from "styled-components"
import Marker from "../../../static/assets/icons/location-marker.svg"
import Map from "./google-map"

const Container = styled.div`
  .address {
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: left;
    padding-top: 12px;
  }
`

const MapBox = styled.div`
  height: fit-content;
  border: 1.5px solid #aaa;
  border-radius: 6px;
  overflow: hidden;
`

const FindUs = ({ address }) => {
  return (
    <Container>
      <MapBox>
        <Map />
      </MapBox>
      <div className="address">
        <Marker />
        <div dangerouslySetInnerHTML={{ __html: address }} />
      </div>
    </Container>
  )
}

export default FindUs
